/* unplugin-vue-components disabled */import script from "./ask-cell.vue?vue&type=script&setup=true&lang=js"
export * from "./ask-cell.vue?vue&type=script&setup=true&lang=js"

import "./ask-cell.vue?vue&type=style&index=0&id=75eacf9e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\work\\space-0\\fsplus-vue-workspace\\foshan-street\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75eacf9e"]])

export default __exports__